module.exports = __webpack_public_path__ + "img/16581247_L.ffffbdf8.png";